import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.cmcp_user_assigned_uid !== model.cmcp_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.cmcp_user_modified_uid,
						assignedTo: modifiedModel.cmcp_user_assigned_uid,
						title: 'Nuova Campagna Commerciale assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.cmcp_title}".`,
						url: `${window.location.origin}/commercialcampaigns/details/${model.cmcp_uid}`,
						icon: 'binoculars',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
